import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ShowMessageEvent, MessageType } from './../model/show-message.event';
import { UserDialogOptions, UserDialogService } from './user-dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslationParameters } from './language.service';

@Injectable()
export class MessageService {
  constructor(private _dialogService: UserDialogService) {}

  private subject = new Subject<ShowMessageEvent>();
  showMessage$ = this.subject.asObservable();

  showError(error: any, parameters?: TranslationParameters) {
    let message = this.resolveMessage(error);

    if (message) {
      this.subject.next(new ShowMessageEvent(MessageType.Error, message, parameters));
    }
  }

  private resolveMessage(error: any): string {
    let message: string = null;
    if (error.error instanceof Error || (error.error && error.error.message)) {
      message = error.error.message;
    } else if (error instanceof HttpErrorResponse) {
      const response = error;
      if (response.error && response.error.message) {
        message = response.error.message;
      } else {
        message = response.message;
      }
    } else if (typeof error === 'string') {
      message = error;
    } else {
      message = 'ERROR.UNKNOWN';
    }
    console.debug(error);
    return message;
  }

  showDialog(message: string, param?: UserDialogOptions | {}): Observable<boolean> {
    return this._dialogService.show(message, param);
  }

  showMessage(message: string, parameters?: TranslationParameters) {
    this.subject.next(new ShowMessageEvent(MessageType.Information, message, parameters));
  }

  showSuccess(message?: string, parameters?: TranslationParameters) {
    if (!message) message = 'SUCCESS_TEXT';
    this.subject.next(new ShowMessageEvent(MessageType.Success, message, parameters));
  }

  showWarning(message: any, parameters?: TranslationParameters) {
    this.subject.next(new ShowMessageEvent(MessageType.Warning, this.resolveMessage(message), parameters));
  }
}
